// extracted by mini-css-extract-plugin
export default {"app":"WcX0G","collapsed":"ZvRA5","app-store":"sFOlX","sticky-img":"Y2yEw","app-phone":"CAHmz","secondary":"YNvfU","tertiary":"EqHVQ"};